import { render, staticRenderFns } from "./riskAssessmentRisks.vue?vue&type=template&id=2400abbe&scoped=true"
import script from "./riskAssessmentRisks.vue?vue&type=script&lang=js"
export * from "./riskAssessmentRisks.vue?vue&type=script&lang=js"
import style0 from "./riskAssessmentRisks.vue?vue&type=style&index=0&id=2400abbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2400abbe",
  null
  
)

export default component.exports